module.exports = __webpack_public_path__ + "img/citation.b409b222.png";